/* Lune Soie — simple pub/sub */
(function () {
  const subscribers = {};
  window.subscribe = function (event, cb) {
    (subscribers[event] = subscribers[event] || []).push(cb);
    return () => {
      subscribers[event] = (subscribers[event] || []).filter((fn) => fn !== cb);
    };
  };
  window.publish = function (event, data) {
    (subscribers[event] || []).forEach((cb) => {
      try { cb(data); } catch (e) { console.error(e); }
    });
  };
})();
